"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MixOn_exports = {};
__export(MixOn_exports, {
  default: () => MixOn_default
});
module.exports = __toCommonJS(MixOn_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.875 0.25C20.0443 0.25 20.1875 0.315104 20.3047 0.445312C20.4349 0.5625 20.5 0.705729 20.5 0.875V19.625C20.5 19.7943 20.4349 19.9375 20.3047 20.0547C20.1875 20.1849 20.0443 20.25 19.875 20.25H1.125C0.955729 20.25 0.80599 20.1849 0.675781 20.0547C0.558594 19.9375 0.5 19.7943 0.5 19.625V0.875C0.5 0.705729 0.558594 0.5625 0.675781 0.445312C0.80599 0.315104 0.955729 0.25 1.125 0.25H19.875ZM13.4688 11.2461C13.3646 11.2591 13.2669 11.2852 13.1758 11.3242C13.0977 11.3633 13.026 11.4154 12.9609 11.4805C12.9089 11.5326 12.8633 11.5911 12.8242 11.6562C12.7982 11.7083 12.7786 11.7734 12.7656 11.8516V11.9688V12.0859V12.125C12.7786 12.138 12.7852 12.1641 12.7852 12.2031C12.7982 12.2292 12.8112 12.2552 12.8242 12.2812L12.8633 12.3398L12.9023 12.418L14.6602 14.5859L12.9023 16.832L12.8633 16.8906L12.8047 16.9883C12.7786 17.0534 12.7591 17.125 12.7461 17.2031C12.7461 17.2682 12.7526 17.3398 12.7656 17.418C12.7786 17.4831 12.8047 17.5482 12.8438 17.6133C12.8828 17.6784 12.9284 17.737 12.9805 17.7891L13.0781 17.8672L13.1367 17.9062C13.1497 17.9193 13.1693 17.9323 13.1953 17.9453C13.2214 17.9453 13.2539 17.9518 13.293 17.9648L13.3906 17.9844L13.5078 18.0039H17.6875L17.8047 17.9844C17.8568 17.9714 17.9089 17.9518 17.9609 17.9258C18.013 17.8867 18.0586 17.8477 18.0977 17.8086C18.1237 17.7695 18.1497 17.7305 18.1758 17.6914C18.2018 17.6393 18.2214 17.5938 18.2344 17.5547L18.2539 17.4375V16.168L18.2344 16.0703C18.2214 16.0052 18.1953 15.9466 18.1562 15.8945C18.1302 15.8424 18.0911 15.7969 18.0391 15.7578C18 15.7188 17.9544 15.6927 17.9023 15.6797C17.8633 15.6536 17.8242 15.6341 17.7852 15.6211L17.668 15.6016H17.5898L17.4727 15.6211C17.4206 15.6341 17.3685 15.6602 17.3164 15.6992C17.2643 15.7253 17.2188 15.7578 17.1797 15.7969C17.1536 15.8359 17.1276 15.875 17.1016 15.9141C17.0755 15.9531 17.056 15.9987 17.043 16.0508L17.0234 16.168V16.8125H14.4648L15.9297 14.918L15.9688 14.8789L16.0078 14.7812C16.0208 14.7422 16.0273 14.7031 16.0273 14.6641C16.0404 14.612 16.0469 14.5664 16.0469 14.5273C16.0469 14.4883 16.0404 14.4492 16.0273 14.4102C16.0143 14.3711 16.0013 14.3385 15.9883 14.3125L15.9492 14.2344L14.4844 12.4375H17.0234V13.082L17.043 13.1797C17.056 13.2448 17.0755 13.3034 17.1016 13.3555C17.1406 13.4076 17.1862 13.4531 17.2383 13.4922C17.2904 13.5443 17.349 13.5833 17.4141 13.6094C17.4922 13.6354 17.5638 13.6484 17.6289 13.6484C17.7201 13.6484 17.7982 13.6354 17.8633 13.6094C17.9414 13.5703 18.0065 13.5247 18.0586 13.4727C18.0977 13.4336 18.1302 13.3945 18.1562 13.3555C18.1953 13.3034 18.2214 13.2513 18.2344 13.1992L18.2539 13.082V11.8125L18.2344 11.6758C18.2083 11.6237 18.1823 11.5781 18.1562 11.5391C18.1302 11.487 18.0911 11.4414 18.0391 11.4023C18 11.3633 17.9609 11.3372 17.9219 11.3242C17.8828 11.2982 17.8372 11.2786 17.7852 11.2656L17.668 11.2461H13.4688ZM11.418 3.19922H10.1484L10.0508 3.21875C9.93359 3.23177 9.82943 3.27734 9.73828 3.35547C9.66016 3.42057 9.60156 3.50521 9.5625 3.60938L4.77734 15.6406L4.73828 15.7578C4.71224 15.901 4.73177 16.0378 4.79688 16.168C4.875 16.2982 4.98568 16.3958 5.12891 16.4609C5.16797 16.474 5.20703 16.487 5.24609 16.5C5.28516 16.5 5.32422 16.5 5.36328 16.5H5.96875H6.08594C6.1901 16.474 6.28125 16.4284 6.35938 16.3633C6.45052 16.2852 6.51562 16.194 6.55469 16.0898L7.66797 13.1992L7.70703 13.1016C7.75911 12.9974 7.83073 12.9193 7.92188 12.8672C8.02604 12.8151 8.13021 12.7891 8.23438 12.7891H11.9648L11.9258 12.7109C11.8997 12.6589 11.8737 12.6068 11.8477 12.5547C11.8346 12.5026 11.8216 12.444 11.8086 12.3789L11.7891 12.2617L11.75 12.0859L11.7695 11.8711L11.7891 11.6562L11.8086 11.5391L11.457 11.0703L9.36719 11.0898L9.26953 11.0703C9.11328 11.0443 8.98307 10.9727 8.87891 10.8555C8.78776 10.7383 8.74219 10.6081 8.74219 10.4648C8.74219 10.4258 8.74219 10.3867 8.74219 10.3477C8.75521 10.3086 8.77474 10.2695 8.80078 10.2305L10.1484 6.63672L10.207 6.53906C10.2852 6.40885 10.3958 6.32422 10.5391 6.28516C10.6823 6.23307 10.8255 6.23307 10.9688 6.28516C11.0469 6.3112 11.1185 6.35677 11.1836 6.42188C11.2487 6.48698 11.2943 6.55859 11.3203 6.63672L12.707 10.2305L12.7461 10.3281V10.4258C12.8372 10.3867 12.9284 10.3542 13.0195 10.3281C13.1237 10.2891 13.2279 10.263 13.332 10.25H13.4688H14.6406L12.0039 3.60938L11.9453 3.51172C11.8932 3.42057 11.8216 3.34896 11.7305 3.29688C11.6393 3.23177 11.5352 3.19922 11.418 3.19922Z",
      fill: "currentColor"
    }
  )
);
const SvgMixOn = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MixOn_default = SvgMixOn;
